<template>
    <section id="out-of-beta-modal">       
        <b-modal 
            id="out-of-beta" 
            @hide = "hideModal"
            centered
            hide-header hide-footer>
            <div id="out-of-beta-swiper-container" 
                class="position-relative" 
                >
                <Icon icon="close-modal" class="close-icon" @click.native="hideModal"/>
                <swiper ref="betaSwiper" class="swiper position-relative" :options="swiperOption">

                    <!-- uncomment when recommendations will be back -->
                    <!-- <swiper-slide> -->
                        <!-- <div class="out-of-beta-container mt-3">
                            <h2 class="text-center h4b mb-4">What's New</h2>
                            <ol>
                                <li class="c1 p5b">
                                    <span class="mb-2 d-block">Recommendations</span>
                                    <div class="p2n c6">
                                        <p>Find your personal recommendations on the best matching campiagns.</p>
                                        <p class="p2n mb-1">Recommendations are based on: <b class="c6">Number of Backers, Category match</b> and <b class="c6">Tags.</b></p>
                                    </div>
                                </li>
                            </ol>
                            <img class="full-image" src="/img/new-recommendations.jpg" alt="">
                        </div>
                        <div class="actions"> -->
                            <!-- <Button class="btn-purple ml-4 button-next">Next</Button> -->
                        <!-- </div> -->
                    <!-- </swiper-slide> -->

                    <swiper-slide>
                        <div class="out-of-beta-container mt-3">
                            <h2 class="text-center h4b mb-4">What's New</h2>
                            <ol start="1" class="mb-4">
                                <li class="c1 p5b">
                                    <span class="mb-2 d-block">Confirm your CrossProm Requests right from  <br> your inbox</span>
                                    <p class="p2n c6 mb-0">Have a chat with a received request? <br>Confirm and book your update spot right from your inbox.</p>
                                </li>
                            </ol>
                            <img class="full-image" src="/img/new-chat-request-action.jpg" alt="">
                        </div>
                        <div class="actions">
                            <!-- <Button class="btn-outline button-prev">Back</Button> -->
                            <!-- <Button class="btn-purple ml-4 button-next">Next</Button> -->
                        </div>
                    </swiper-slide>
                    <swiper-slide>
                        <div class="out-of-beta-container mt-3">
                            <img src="/img/cherry.png" alt="cherry" class="mx-auto d-block">
                            <h2 class="text-center h4b mb-4">Cherry on Top</h2>
                            <ol start="2" class="mb-4">
                                <li class="c1 p5b">
                                    <span class="mb-2 d-block">Create your Kickstarter update with just one click</span>
                                    <p class="p2n c6">Automatically post your crossproms into your Kickstarter update with just one click.</p>
                                </li>
                            </ol>
                            <img class="full-image" src="/img/new-save-to-kickstarter.jpg" alt="">
                        </div>
                    </swiper-slide>
                </swiper>
                <div class="swiper-pagination" slot="pagination"></div>
                <div class="actions">
                    <Button class="btn-outline button-prev" v-show="swiperActiveIndex">Back</Button>
                    <Button class="btn-purple ml-4 button-next" @click.native="showNext" v-show="swiperActiveIndex<1">Next</Button>
                    <Button class="btn-purple ml-4 button-next" @click.native="hideModal" v-show="swiperActiveIndex===1">Ok</Button>
                </div>
            </div>
        </b-modal>
    </section>
</template>

<script>
import {mapState} from 'vuex'
import Icon from '../components/Theme/Icon'
import {CloseCross} from '../components/Icons'
import Button from '../components/Theme/Button'
import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue";
export default {
    data() {
        return {
            swiperActiveIndex: 0,
            swiperOption: {
                slidesPerView: 1,
                keyboard: {
                    enabled: true,
                },
                allowTouchMove: false,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                navigation: {
                    nextEl: ".button-next",
                    prevEl: ".button-prev",
                },
                activeIndexChange: this.indexChnaged
            }
        }
    },
    mounted() {
        this.$bvModal.show('out-of-beta')
        this.$sendMixpanelEvent('Out Of Beta Modal Opened')
        this.$ga.event('Pricing', 'Out Of Beta Modal Opened')

        this.$nextTick(() => {
            this.$refs.betaSwiper.swiper.on('activeIndexChange', () => {
                this.swiperActiveIndex = this.$refs.betaSwiper.swiper.activeIndex
            });
        })
    },
    computed: {
        ...mapState(['modals']),
    },
    components: {
        Icon,
        CloseCross,
        Button,
        LottieAnimation
    },
    methods: {
        indexChnaged(a){
            console.log(a)
        },
        showNext(){
            this.trackEvent()
            if(this.swiperActiveIndex === 2) {
                this.hideModal()
            }
        },
        hideModal(){
            this.$bvModal.hide('out-of-beta');
            setTimeout(() => {
                this.$store.commit('TOGGLE_MODAL', ['out-of-beta', false]);

                if(!this.$store.state.publishedCampaignIds.length) {
                    this.$store.commit('TOGGLE_MODAL', ['cp-request', true])
                }
            }, 100)
        },
        trackEvent(){
            this.$sendMixpanelEvent('Out Of Beta Modal Next Button Clicked')
            this.$ga.event('Pricing', 'Out Of Beta Modal Next Button Click')
        }
    }
}
</script>

<style lang="scss">
@import '../assets/scss/variables';
#out-of-beta-swiper-container {
    border-radius: 16px;
    width: 560px;
    background-color: #fff;
    padding-bottom: 30px;
    
    ol {
        list-style: decimal;

        li {
            line-height: 25px;
        }
    }

    ul {
        line-height:25px;
    }

    ul li{
        list-style: disc!important;
    }

    .out-of-beta-container {
        transition: .5s;

        .full-image {
            max-width: calc(100% + 30px);
            position: relative;
            left: -15px;
        }
       
        .options-list {
            width: 80%;
            margin: 0 auto;
        }
    }

    .close-icon {
        position: absolute;
        z-index: 300;
        right: 15px;
        top: 15px;
        cursor: pointer;
    }

    .actions {
        text-align: right;
        padding-right: 15px;
    }

    .swiper-pagination {
        text-align: left;
        margin-left: 30px;
        margin-top: 12px;
        width: 100px;
        .swiper-pagination-bullet {
            margin: 0 3px;
        }
        .swiper-pagination-bullet-active {
            background-color: $c1
        }
    }

    ol.options-list li {
        margin-bottom: 20px;
    }

    ol.options-list li {
        color: $c1;
        font-weight: 700;
        font-size: 16px;
    }
}
</style>